import { Component, createContext, useState } from "react";
import { Route, Routes } from "react-router-dom";
import './App.css';
import AlarmHistory from "./pages/dashboard/BatteryBMS/AlarmHistory";
import BatteryBMS from "./pages/dashboard/BatteryBMS/BatteryBMS";
import ActiveBalance from "./pages/dashboard/BatteryBMS/BMSSettings/ActiveBalance";
import CurrentProtectiohn from "./pages/dashboard/BatteryBMS/BMSSettings/CurrentProtection";
import SettingModal from "./pages/dashboard/BatteryBMS/BMSSettings/SettingModal";
import Settings from "./pages/dashboard/BatteryBMS/BMSSettings/Settings";
import TempProtection from "./pages/dashboard/BatteryBMS/BMSSettings/TempProtection";
import ControllModal from "./pages/dashboard/BatteryBMS/ControllModal";
import Controlls from "./pages/dashboard/BatteryBMS/Controlls";
import DataMonitoring from "./pages/dashboard/BatteryBMS/DataMonitoring";
import ParameterSettings from "./pages/dashboard/BatteryBMS/ParameterSettings";
import Dashboard from "./pages/dashboard/Dashboard";
import DashboardIndex from "./pages/dashboard/DashboardIndex";
import ProfileModal from "./pages/dashboard/Profile/ProfileModal";
import { dashboardRoutes } from "./routes/dashboardRoutes";
import { publicRoutes } from "./routes/publicRoutes";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useLiveBMSData from "./hooks/useLiveBMSData";
import UserDeleteModal from "./pages/dashboard/Users/UserDeleteModal";
import UserEditModal from "./pages/dashboard/Users/UserEditModal";
import RequireAuth from "./pages/auth/RequireAuth/RequireAuth";
import AddDeviceModal from "./pages/dashboard/Users/AddDeviceModal";
import DeviceEditModal from "./pages/dashboard/Users/DeviceEditModal";
import DeviceDeleteModal from "./pages/dashboard/Users/DeviceDeleteModal";
import { useEffect } from "react";
import RequireAdmin from "./pages/auth/RequireAdmin/RequireAdmin";
import AdminDashboard from "./pages/dashboard/Admin/AdminDashboard";
import { adminRoutes } from "./routes/adminRoutes";
import { useAuthState } from "react-firebase-hooks/auth";
import useAdmin from "./hooks/useAdmin";
import auth from "./firebase.init";
import Profile from "./pages/dashboard/Profile/Profile";


export const ControllContext = createContext();
export const BmsContext = createContext();

function App() {

  // Live BMS hook 
  const [liveBMSData] = useLiveBMSData();
  const [user, loading] = useAuthState(auth);
  const [admin, adminLoading] = useAdmin(user);

  // Controll Stats 
  const [showControllModal, setShowControllModal] = useState(false);
  const [inputControllPass, setInputControllPass] = useState('');
  const [controllName, setControllName] = useState('');
  const [charge, setCharge] = useState(false);
  const [disCharge, setDisCharge] = useState(false);
  const [balance, setBalance] = useState(false);
  const [emergency, setEmergency] = useState(false);

  // Sidebar state 
  const [sidebarHide, setSidebarHide] = useState(false);

  // User Edit state 
  const [editUser, setEditUser] = useState({});
  const [isEditUserModal, setIsEditUserModal] = useState(false);

  // User Delete State 
  const [deleteUser, setDeleteUser] = useState(null);
  const [isDeleteUserModal, setIsDeleteUserModal] = useState(false);


  // Switching controll by response from server -----------------------
  const chargeMosState = liveBMSData?.bmsData?.F1?.chargeMosState;
  const disChargeMosState = liveBMSData?.bmsData?.F1?.disChargeMosState;
  const cellBalanceState = liveBMSData?.bmsData?.F1?.cellBalanceState;

  useEffect(() => {
    // changing charge switch 
    if (chargeMosState === "1") {
      setCharge(true);
    } else if (chargeMosState === "0") {
      setCharge(false)
    }

    // changing discharge switch 
    if (disChargeMosState === "1") {
      setDisCharge(true);
    } else if (disChargeMosState === "0") {
      setDisCharge(false)
    }

    // changing balance switch 
    if (cellBalanceState === "1") {
      setBalance(true);
    } else if (cellBalanceState === "0") {
      setBalance(false)
    }

  }, [chargeMosState, disChargeMosState, cellBalanceState]);
  // --------------------------------------------------------------------



  // Onchanging controll button ----------------------------------------
  const handleCharge = () => {
    setShowControllModal(true);
    setControllName('charge');
  }
  const handleDisCharge = () => {
    setShowControllModal(true);
    setControllName('disCharge');
  }
  const handleBalance = () => {
    setShowControllModal(true);
    setControllName('balance');
  }
  const handleEmergency = () => {
    setShowControllModal(true);
    setControllName('emergency');
  }
  // --------------------------------------------------------------------


  // Handle Controll start ----------------------------------------------
  const handleControllSubmit = (e) => {
    e.preventDefault();
    const controllPass = e.target.password.value;
    setInputControllPass(controllPass);

    // Checking Controll password and switch controlls buttons 
    if (controllPass === '123') {
      // Hiding controll modal
      setShowControllModal(false);

      // switching controll button 
      switch (controllName) {
        case "charge":
          setCharge(!charge);
          break;
        case "disCharge":
          setDisCharge(!disCharge);
          break;
        case "balance":
          setBalance(!balance);
          break;
        case "emergency":
          setEmergency(!emergency);
          break;
        default:
          break;
      }

    }

  }
  // --------------------------------------------------------------------


  // Context Area -------------------------------------------------------
  // Controll Context 
  const controllContext = {
    setShowControllModal: setShowControllModal,
    charge: charge,
    disCharge: disCharge,
    balance: balance,
    emergency: emergency,
    handleCharge: handleCharge,
    handleBalance: handleBalance,
    handleDisCharge: handleDisCharge,
    handleEmergency: handleEmergency,
  }


  // Drawer context 
  const sidebarContext = {
    sidebarHide: sidebarHide,
    setSidebarHide: setSidebarHide
  }
  // ---------------------------------------------------------------------


  return (
    <BmsContext.Provider value={{ liveBMSData, sidebarContext, controllContext, setEditUser, setIsEditUserModal, setDeleteUser, setIsDeleteUserModal, admin, adminLoading, user }} >

      {/* All Routes Start Here -------------------------------------------------- */}
      <Routes>

        {/* Public Routes  */}
        {
          publicRoutes.map(({ path, Component }, index) => <Route key={index} path={path} element={<Component></Component>}></Route>)
        }

        {/* Dashboard Routes start  -------------------------------------*/}
        <Route path="/dashboard" element={
          <RequireAuth>
            <Dashboard />
          </RequireAuth>
        }>

          <Route index element={
            admin ? <AdminDashboard /> : <BatteryBMS />
          }></Route>

          {/* Admin Routes  */}
          {/* <Route path="bms-admin" element={<AdminDashboard />}></Route> */}
          {
            adminRoutes.map(({ path, Component }, index) => <Route key={index} path={path} element={
              <RequireAdmin>
                <Component />
              </RequireAdmin>
            } />)
          }

          {/* Normal user dashboard Routes  */}
          {
            dashboardRoutes.map(({ path, Component }, index) => <Route key={index} path={path} element={<Component />} />)
          }

          <Route path="parameter-settings" element={<ParameterSettings />}>
            <Route path="active-balance" element={<ActiveBalance />}></Route>
            <Route path="current-protection" element={<CurrentProtectiohn />}></Route>
            <Route path="temp-protection" element={<TempProtection />}></Route>
            <Route path="parameter-setting" element={<Settings />}></Route>
          </Route>


          {/* Profile Route  */}
          <Route path="profile" element={<Profile />}>
            <Route path="data-monitoring" element={<DataMonitoring />}></Route>
          </Route>



        </Route>
        {/* Dashboard Routes end ---------------------------------------------------- */}

      </Routes>
      {/* All Routes End Here -------------------------------------------------- */}


      {/* All Modals start -------------------------------------------------- */}
      <ProfileModal />
      <ControllModal
        showControllModal={showControllModal}
        setShowControllModal={setShowControllModal}
        handleControllSubmit={handleControllSubmit}
      />
      <SettingModal />
      {/* user delete modal  */}
      {isDeleteUserModal && <UserDeleteModal deleteUser={deleteUser} setDeleteUser={setDeleteUser} setIsDeleteUserModal={setIsDeleteUserModal} />}
      {/* user info delte modal  */}
      {isEditUserModal && <UserEditModal user={editUser} setIsEditUserModal={setIsEditUserModal} />}
      <AddDeviceModal />
      <DeviceEditModal />
      <DeviceDeleteModal />
      {/* All Modals end ----------------------------------------------------- */}

      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </BmsContext.Provider>

  );
}

export default App;
